import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=191897d6&scoped=true"
import script from "./alert-dialog.vue?vue&type=script&lang=js"
export * from "./alert-dialog.vue?vue&type=script&lang=js"
import style0 from "./alert-dialog.vue?vue&type=style&index=0&id=191897d6&prod&lang=scss"
import style1 from "./alert-dialog.vue?vue&type=style&index=1&id=191897d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191897d6",
  null
  
)

export default component.exports